// DiagramContainer.jsx


import { motion } from 'motion/react';

export function DiagramContainer({ children, className = '', hoverable = true }) {
  return (
    <motion.div
      transition={{ duration: 0.3 }}
      className={`relative rounded-xl p-6 ${className}`}
      style={{
        background: 'linear-gradient(135deg, #F7FAFC 0%, #EDF2F7 100%)',
        minHeight: '320px',
      }}
      whileHover={hoverable
        ? {
          background: 'linear-gradient(135deg, #EDF2F7 0%, #E2E8F0 100%)',
          boxShadow: '0 20px 40px rgba(41, 115, 163, 0.15)',
        }
        : undefined}
    >
      {/* Grid Overlay Pattern */}
      <div className="absolute inset-0 pointer-events-none rounded-xl overflow-hidden">
        <svg className="w-full h-full" style={{ opacity: 0.18 }}>
          <defs>
            <pattern
              width="40"
              height="40"
              id="diagram-grid"
              patternUnits="userSpaceOnUse"
            >
              <path
                fill="none"
                strokeWidth="1"
                stroke="#D6E4F0"
                d="M 40 0 L 0 0 0 40"
              />
            </pattern>
          </defs>

          <rect width="100%" height="100%" fill="url(#diagram-grid)" />
        </svg>
      </div>

      {/* Content with proper z-index */}
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );
}

// Dark mode variant for future use
export function DiagramContainerDark({ children, className = '', hoverable = true }) {
  return (
    <motion.div
      transition={{ duration: 0.3 }}
      className={`relative rounded-xl p-6 ${className}`}
      style={{
        background: 'linear-gradient(135deg, #1A365D 0%, #2D3748 100%)',
        minHeight: '320px',
      }}
      whileHover={hoverable
        ? {
          background: 'linear-gradient(135deg, #2D3748 0%, #4A5568 100%)',
          boxShadow: '0 20px 40px rgba(59, 130, 246, 0.15)',
        }
        : undefined}
    >
      {/* Grid Overlay Pattern for Dark Mode */}
      <div className="absolute inset-0 pointer-events-none rounded-xl overflow-hidden">
        <svg className="w-full h-full" style={{ opacity: 0.15 }}>
          <defs>
            <pattern
              width="40"
              height="40"
              id="diagram-grid-dark"
              patternUnits="userSpaceOnUse"
            >
              <path
                fill="none"
                strokeWidth="1"
                stroke="#CBD5E0"
                d="M 40 0 L 0 0 0 40"
              />
            </pattern>
          </defs>

          <rect width="100%" height="100%" fill="url(#diagram-grid-dark)" />
        </svg>
      </div>

      {/* Content with proper z-index */}
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );
}
